import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=60a8d3a4&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=60a8d3a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8d3a4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/plate/index.vue"
export default component.exports